<div class="flex items-center">
  <div>
    <ark-icon
      icon="system-up"
      size="medium"
      color="inactive"
      (click)="upvoted.emit()"
    ></ark-icon>
  </div>
  <div class="text-gray-500 text-base px-2">
    {{ upvoteCount }}
  </div>
  <div>
    <ark-icon
      icon="system-down"
      size="medium"
      color="inactive"
      (click)="downvoted.emit()"
    ></ark-icon>
  </div>
</div>
